import {NodeContext} from '../../../../../../../@polygonjs/polygonjs/src/engine/poly/NodeContext';
import {SubnetGlNode} from '../../../../../../../@polygonjs/polygonjs/src/engine/nodes/gl/Subnet';
import {NodeCodeExporter} from '../../Node';
import {NodesCodeExporterOption} from '../../Nodes';

export class SubnetGlCodeExporter extends NodeCodeExporter<NodeContext.GL> {
	constructor(protected override _node: SubnetGlNode, options: NodesCodeExporterOption) {
		super(_node, options);
	}

	protected override _preAddChildren() {
		// this node needs to create the params before the children
		// so that the input connections are created,
		// and so that the subnet inputs and outputs can have the right connections
		this.add_params();
	}
}
